"use client"

import Image from "next/image"
import { useTheme } from "@/components/theme-provider"
import { cn } from "@/lib/utils"

interface LogoProps {
  className?: string
  width?: number
  height?: number
  variant?: "full" | "icon"
}

export function Logo({ className, width = 120, height = 32, variant = "full" }: LogoProps) {
  const { theme, resolvedTheme } = useTheme()

  // Use resolvedTheme to handle 'system' preference
  const effectiveTheme = resolvedTheme || theme

  const logoSrc =
    variant === "icon"
      ? effectiveTheme === "dark"
        ? "/logo-icon-light.png" // White/light icon for dark backgrounds
        : "/logo-icon-dark.png" // Blue icon for light backgrounds
      : effectiveTheme === "dark"
        ? "/logo-light.png" // Light wordmark for dark mode
        : "/logo-dark.png" // Dark wordmark for light mode

  return (
    <Image
      src={logoSrc || "/placeholder.svg"}
      alt="LogosIQ"
      width={width}
      height={height}
      className={cn("object-contain", className)}
      priority
    />
  )
}
